module.exports = __webpack_public_path__ + "img/smg_luckytwinswilds_banner_715x360_th.09d62554.gif";